// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, WithClass, WithTagName } from "./Dom";
import { WebPageComponent } from "./WebSite.Page.Component";

export class MoneyField extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    if (this.inputField != null) {
      this.inputField.onfocus = (event) => { this.element.classList.add("Focus"); };
      this.inputField.onblur = (event) => { this.element.classList.remove("Focus"); };
    }
  }

  determineElements() {
    this.textField = new DomQuery(this.element).getChild(WithClass("SingleLineTextField"));

    if (this.textField !== null)
      this.inputField = new DomQuery(this.textField).getChild(WithTagName("INPUT"));
  }
}

interactivityRegistration.register("Money", function (element) { return new MoneyField(element); });
